/*
 * @Author: Latte
 * @Date: 2021-08-19 18:03:35
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-07 12:18:42
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\liveManagement\liveConfig.js
 */
import request from '@/utils/request'
import config from '@/utils/config'

/**
 * 直播配置
 */

/**
 * @description: 获取直播配置接口
 * @param {*} params
 * @return {*}
 */
export function getLiveConfig(params) {
  return request({
    url: config.API_LIVE + '/live_server/manage/live/appConfig',
    method: 'get',
    params
  })
}

/**
 * @description: 设置直播配置接口
 * @param {*} data
 * @return {*}
 */
export function setLiveConfig(data) {
  return request({
    url: config.API_LIVE + '/live_server/manage/live/appConfig',
    method: 'post',
    data
  })
}